import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(
  ({ className = "", sideOffset = 4, style, ...props }, ref) => (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={className}
      style={{
        zIndex: 50,
        overflow: "hidden",
        borderRadius: "8px",
        border: "1px solid rgba(15, 23, 42, 0.08)",
        backgroundColor: "#fff",
        padding: "6px 12px",
        fontSize: "0.875rem",
        lineHeight: 1.4,
        color: "#111827",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.18)",
        ...style,
      }}
      {...props}
    />
  )
)
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }


